module.exports = __webpack_public_path__ + "img/Chemical Science.b85fc118.jpg";